// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TablaComparacionPorItemDeLaCategoria__SorteableHeaderTitle__H6AQ5:hover{\r\n  color: rgba(0, 0, 0, 0.54);\r\n  cursor: pointer;\r\n}\r\n\r\n.TablaComparacionPorItemDeLaCategoria__TablasComparacionComprobantesContainer__8uEUp{\r\n  display: flex;\r\n  flex-direction: row;\r\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SorteableHeaderTitle": "TablaComparacionPorItemDeLaCategoria__SorteableHeaderTitle__H6AQ5",
	"TablasComparacionComprobantesContainer": "TablaComparacionPorItemDeLaCategoria__TablasComparacionComprobantesContainer__8uEUp"
};
export default ___CSS_LOADER_EXPORT___;
